export enum AdminDictionaryListAction {
  Create,
}
